<app-complex-modal-template
    [canConfirm]="!!selectedPeopleOptions().length && !!selectedFormOptions().length"
    [customLabel]="data.updateMode ? ('updatePlanning' | transloco) : ('startPlanning' | transloco)"
    [isConfirmationMode]="currentStep() === FieldInterventionPlanningModalStepEnum.FORM"
    [stepNumber]="data.hasLoader ? 2 : 1"
    [title]="
        data.updateMode
            ? ('updatePlanning' | transloco)
            : ('planFieldInterventionEntity' | transloco: { COUNT: data.numberOfEntities })
    "
    [(currentStep)]="currentStep"
    (onClickEvent)="closeModal($event)">
    @if (currentStep() === FieldInterventionPlanningModalStepEnum.FORM) {
        <div class="flex flex-col justify-between gap-5 w-2/3">
            <div>
                <app-select
                    placeholder="selectOperators"
                    [isIntermediateStateEnabled]="data.isIntermediateStateEnabled"
                    [isMultiSelect]="true"
                    [label]="'operator' | transloco"
                    [options]="peopleOptions()"
                    [(selectedOptions)]="selectedPeopleOptions"
                    (optionToggled)="onOptionToggled($event, AttributionTypeEnum.PEOPLE)" />
            </div>
            <div>
                <app-select
                    placeholder="selectForms"
                    [isIntermediateStateEnabled]="data.isIntermediateStateEnabled"
                    [isMultiSelect]="true"
                    [label]="'form' | transloco"
                    [options]="formOptions()"
                    [(selectedOptions)]="selectedFormOptions"
                    (optionToggled)="onOptionToggled($event, AttributionTypeEnum.FORM)" />
            </div>
        </div>
    }
    @if (currentStep() === FieldInterventionPlanningModalStepEnum.IN_PROGRESS && data.hasLoader) {
        <div class="flex justify-center items-center w-full h-full py-10">
            @if (isProgressBarNeeded()) {
                <app-progress-bar
                    class="w-full"
                    [itemsLoaded]="entitiesLoaded()"
                    [total]="data.numberOfEntities" />
            } @else {
                <fa-icon
                    size="6x"
                    [class]="'text-custom-blue fa-spin'"
                    [icon]="['fad', 'spinner-third']"
                    [matTooltip]="'extracting' | transloco" />
            }
        </div>
    }
</app-complex-modal-template>
